import { createSlice } from "@reduxjs/toolkit";
import { IKeywordBoost, IKeywordBoostV2, IKeywordExclude, IKeywordNaver, IKeywordRealTime, IKeywordTask } from "api/types/_keyword";
import { PaginationResponse, ResponseData } from "api/types/_public";
import { getKeywordBoosts, getKeywordBoostV2s, getKeywordExcludes, getKeywordGoldens, getKeywordNavers, getKeywordRealTimes, getKeywordTasks } from "./thunk";


export interface IState {
  keywordBoosts: ResponseData<IKeywordBoost[]> & PaginationResponse | null,
  isKeywordBoostLoading: boolean,
  isKeywordBoostSuccess: boolean,

  allKeywordBoost: ResponseData<IKeywordBoost[]> | null,

  keywordBoostV2s: ResponseData<IKeywordBoostV2[]> & PaginationResponse | null,
  isKeywordBoostV2Loading: boolean,
  isKeywordBoostV2Success: boolean,

  keywordTasks: ResponseData<IKeywordTask[]> & PaginationResponse | null,
  isKeywordTaskLoading: boolean,
  isKeywordTaskSuccess: boolean,

  keywordGoldens: ResponseData<IKeywordBoostV2[]> & PaginationResponse | null,
  isKeywordGoldenLoading: boolean,
  isKeywordGoldenSuccess: boolean,

  keywordNavers: ResponseData<IKeywordNaver[]> & PaginationResponse | null,
  isKeywordNaverLoading: boolean,
  isKeywordNaverSuccess: boolean,

  keywordRealTimes: ResponseData<IKeywordRealTime[]> & PaginationResponse | null,
  isKeywordRealTimeLoading: boolean,
  isKeywordRealTimeSuccess: boolean,


  keywordExcludes: ResponseData<IKeywordExclude[]> & PaginationResponse | null,
  isKeywordExcludeLoading: boolean,
  isKeywordExcludeSuccess: boolean,

  error: any,
};

export const initialState: IState = {
  keywordBoosts: null,
  isKeywordBoostLoading: false,
  isKeywordBoostSuccess: false,

  allKeywordBoost: null,

  keywordBoostV2s: null,
  isKeywordBoostV2Loading: false,
  isKeywordBoostV2Success: false,

  keywordTasks: null,
  isKeywordTaskLoading: false,
  isKeywordTaskSuccess: false,

  keywordGoldens: null,
  isKeywordGoldenLoading: false,
  isKeywordGoldenSuccess: false,

  keywordNavers: null,
  isKeywordNaverLoading: false,
  isKeywordNaverSuccess: false,

  keywordRealTimes: null,
  isKeywordRealTimeLoading: false,
  isKeywordRealTimeSuccess: false,

  keywordExcludes: null,
  isKeywordExcludeLoading: false,
  isKeywordExcludeSuccess: false,

  error: {},
};

const KeywordSlice = createSlice({
  name: "Keyword",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get KeywordBoosts
    builder.addCase(getKeywordBoosts.pending, (state: IState, action: any) => {
      state.isKeywordBoostLoading = true
    });
    builder.addCase(getKeywordBoosts.fulfilled, (state: IState, action: any) => {
      state.keywordBoosts = action.payload.data;
      state.isKeywordBoostSuccess = true;
      state.isKeywordBoostLoading = false;
    });
    builder.addCase(getKeywordBoosts.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isKeywordBoostSuccess = false;
      state.isKeywordBoostLoading = false;
    });

    //get KeywordBoostV2s
    builder.addCase(getKeywordBoostV2s.pending, (state: IState, action: any) => {
      state.isKeywordBoostV2Loading = true
    });
    builder.addCase(getKeywordBoostV2s.fulfilled, (state: IState, action: any) => {
      state.keywordBoostV2s = action.payload.data;
      state.isKeywordBoostV2Success = true;
      state.isKeywordBoostV2Loading = false;
    });
    builder.addCase(getKeywordBoostV2s.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isKeywordBoostV2Success = false;
      state.isKeywordBoostV2Loading = false;
    });


    //get KeywordTasks
    builder.addCase(getKeywordTasks.pending, (state: IState, action: any) => {
      state.isKeywordTaskLoading = true
    });
    builder.addCase(getKeywordTasks.fulfilled, (state: IState, action: any) => {
      state.keywordTasks = action.payload.data;
      state.isKeywordTaskSuccess = true;
      state.isKeywordTaskLoading = false;
    });
    builder.addCase(getKeywordTasks.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isKeywordTaskSuccess = false;
      state.isKeywordTaskLoading = false;
    });

    //get KeywordGoldens
    builder.addCase(getKeywordGoldens.pending, (state: IState, action: any) => {
      state.isKeywordGoldenLoading = true
    });
    builder.addCase(getKeywordGoldens.fulfilled, (state: IState, action: any) => {
      state.keywordGoldens = action.payload.data;
      state.isKeywordGoldenSuccess = true;
      state.isKeywordGoldenLoading = false;
    });
    builder.addCase(getKeywordGoldens.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isKeywordGoldenSuccess = false;
      state.isKeywordGoldenLoading = false;
    });


    //get KeywordNavers
    builder.addCase(getKeywordNavers.pending, (state: IState, action: any) => {
      state.isKeywordNaverLoading = true
    });
    builder.addCase(getKeywordNavers.fulfilled, (state: IState, action: any) => {
      state.keywordNavers = action.payload.data;
      state.isKeywordNaverSuccess = true;
      state.isKeywordNaverLoading = false;
    });
    builder.addCase(getKeywordNavers.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isKeywordNaverSuccess = false;
      state.isKeywordNaverLoading = false;
    });

    //get KeywordRealTimes
    builder.addCase(getKeywordRealTimes.pending, (state: IState, action: any) => {
      state.isKeywordRealTimeLoading = true
    });
    builder.addCase(getKeywordRealTimes.fulfilled, (state: IState, action: any) => {
      state.keywordRealTimes = action.payload.data;
      state.isKeywordRealTimeSuccess = true;
      state.isKeywordRealTimeLoading = false;
    });
    builder.addCase(getKeywordRealTimes.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isKeywordRealTimeSuccess = false;
      state.isKeywordRealTimeLoading = false;
    });


    //get KeywordExcludes
    builder.addCase(getKeywordExcludes.pending, (state: IState, action: any) => {
      state.isKeywordExcludeLoading = true
    });
    builder.addCase(getKeywordExcludes.fulfilled, (state: IState, action: any) => {
      state.keywordExcludes = action.payload.data;
      state.isKeywordExcludeSuccess = true;
      state.isKeywordExcludeLoading = false;
    });
    builder.addCase(getKeywordExcludes.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isKeywordExcludeSuccess = false;
      state.isKeywordExcludeLoading = false;
    });
  },
});

export default KeywordSlice.reducer;